module.exports = __webpack_public_path__ + "static/media/intagram.a10077e7.svg";